import { Group } from '@mantine/core';
import { IconCalendarEvent, IconFilter, IconInbox, IconListCheck, IconMessageCircle } from '@tabler/icons';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConversationsWidget } from '../../../Service/Context/HubspotContext';
import ActionIconWithText from './ActionIconWithText';

interface HandlersProps {
  filter: () => void;
}

const PrimaryFooter: FC<HandlersProps> = ({ filter }) => {
  const { openWidget } = useConversationsWidget();
  const navigate = useNavigate();

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText label="Filter" onClick={filter} useDefaultWidth>
        <IconFilter />
      </ActionIconWithText>
      <ActionIconWithText label="Events" useDefaultWidth onClick={() => navigate('/')}>
        <IconCalendarEvent />
      </ActionIconWithText>
      <ActionIconWithText label="Aufgaben" onClick={() => navigate('/tasks')} useDefaultWidth>
        <IconListCheck />
      </ActionIconWithText>
      <ActionIconWithText useDefaultWidth label="Postfach" onClick={() => navigate('/postbox/inbox')}>
        <IconInbox />
      </ActionIconWithText>
      <ActionIconWithText label="Support" onClick={openWidget} useDefaultWidth>
        <IconMessageCircle />
      </ActionIconWithText>
    </Group>
  );
};

export default PrimaryFooter;
